import { Component } from '@angular/core';
import { AuthService } from './services/api/auth.service';
import { MessagingService } from './services/api/messaging.service';
import { NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import * as bulmaToast from 'bulma-toast';
import { AppsettingsService } from './services/api/appsettings.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { TrackingService } from './services/api/tracking.service';
export let browserRefresh = false
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'carga-shipper-web';
  message;
  buildOption: any = {
    build: "71",
    version: "1.8.0"
  }

  constructor(private messagingService: MessagingService,
    private authsrvc: AuthService,
    private router: Router,
    private location: Location,
    private modalService: NgbModal,
    private appsettingssrvc: AppsettingsService,
    private trackingsrvc: TrackingService) {

    this.messagingService.requestPermission()
    // this.router.events
    //   .subscribe((event: NavigationStart) => {
    //     if (event.navigationTrigger === 'popstate') { }
    //     if (event instanceof NavigationStart) {
    //       browserRefresh = !router.navigated;
    //       // console.log("browserRefresh", browserRefresh)
    //     }
    //   });
  }

  ngOnInit() {
    this.getAppSetting()
    // this.appVersionChecker()
    this.trackingsrvc.initTracking()
    this.authsrvc.ifLoggedIn()
  }

  getAppSetting() {
    let token = localStorage.getItem('authToken')
    let group = JSON.parse(localStorage.getItem('USER_INFO'))
    // console.log("groupId", group);

    this.appsettingssrvc.getNewAppSettings(group.groupId, token).
      then(response => {
        // console.log("new settings", response);
      })
  }

  appVersionChecker() {
    if (localStorage.getItem("AppVersion")) {
      let versionIs = JSON.parse(localStorage.getItem("AppVersion"))
      // console.log("versionIs", versionIs, versionIs.build, this.buildOption.build)
      if (Number(versionIs.build) < Number(this.buildOption.build)) {
        // console.log("need to update app")
        Swal.fire({
          title: 'Available Update',
          text: 'new update available version ' + this.buildOption.version,
          icon: 'info',
          confirmButtonText: 'Reload',
          customClass: 'swal-small',
          width: "30rem"
        }).then((result) => {
          localStorage.setItem("AppVersion", JSON.stringify(this.buildOption))
          window.location.reload()
        })
      }
    } else {
      localStorage.setItem("AppVersion", JSON.stringify(this.buildOption))
    }
  }

}
